import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import {
  SynBreadcrumbComponent,
  SynBreadcrumbItemComponent,
  SynButtonComponent,
  SynCardComponent,
  SynIconComponent,
} from '@synergy-design-system/angular';

@Component({
  selector: 'app-new-client-template',
  template: `
    <syn-breadcrumb>
      <syn-breadcrumb-item routerLink="" i18n="@@home">Home</syn-breadcrumb-item>
      <syn-breadcrumb-item routerLink="/clients" i18n="@@clients">Clients</syn-breadcrumb-item>
      <syn-breadcrumb-item i18n="@@templates">Templates</syn-breadcrumb-item>
    </syn-breadcrumb>

    <h1 i18n="@@client-templates">Client Templates</h1>

    <p class="padding-1" i18n="@@client-templates-explanation">
      Select one of the predefined templates if they fit your use case.
    </p>

    <div class="flex-row gap-2" style="flex-wrap: wrap">
      <syn-card>
        <div class="flex-row space-between">
          <h3>Standalone Web Frontend</h3>
          <syn-icon name="language_fill" class="big-icon" />
        </div>
        <p i18n="@@template-standalone-web-frontend">
          Create an OpenID client for a web frontend,
          e.g. a Single-Page Application (SPA).
          Your users can directly authenticate with SICK ID
          via the browser authentication flow.
        </p>

        <footer slot="footer">
          <nav>
            <syn-button routerLink="../new" [queryParams]="{template: 'frontend'}">
              <span i18n="@@create-client">Create Client</span>
            </syn-button>
          </nav>
        </footer>
      </syn-card>

      <syn-card>
        <div class="flex-row space-between">
          <h3 i18n="@@service-to-service-communication">Service-to-Service Communication</h3>
          <syn-icon name="share_fill" class="big-icon" />
        </div>
        <p i18n="@@template-service-to-service">
          Create an OpenID client for authenticating backend services.
          A service account will be created that can authenticate via
          the client credentials flow.
        </p>

        <footer slot="footer">
          <nav>
            <syn-button routerLink="../new" [queryParams]="{template: 'service'}"
                       data-e2e="btn-create-client-service">
              <span i18n="@@create-client">Create Client</span>
            </syn-button>
          </nav>
        </footer>
      </syn-card>

      <syn-card>
        <div class="flex-row space-between">
          <h3>Advanced: Custom Configuration</h3>
          <syn-icon name="settings_fill" class="big-icon" />
        </div>
        <p i18n="@@template-custom-configuration">
          Create a fully customizable OpenID client.
          This allows advanced users to configure their clients for specific use cases
          not covered by the other templates.
        </p>

        <footer slot="footer">
          <nav>
            <syn-button routerLink="../new" [queryParams]="{template: 'custom'}">
              <span i18n="@@create-client">Create Client</span>
            </syn-button>
          </nav>
        </footer>
      </syn-card>


    </div>
  `,
  styles: [
    `
      .big-icon {
        font-size: var(--syn-font-size-large);
      }

      syn-card {
        width: 27em;
        min-width: 27em;
      }

      syn-card::part(body) {
        min-height: 14em;
      }
    `,
  ],
  imports: [
    RouterLink,
    SynButtonComponent,
    SynIconComponent,
    SynCardComponent,
    SynBreadcrumbComponent,
    SynBreadcrumbItemComponent,
  ],
})
export class NewClientTemplateComponent {

}
